// Porosity Party Theme JS
document.addEventListener('DOMContentLoaded', function () {

  // Size selector
  document.querySelectorAll('.pp-size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var siblings = this.closest('.pp-size-grid').querySelectorAll('.pp-size-btn');
      siblings.forEach(function (s) { s.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Hover animations on char cards
  document.querySelectorAll('.pp-char-card, .pp-product-card, .pp-hero-char-card').forEach(function (card) {
    card.addEventListener('mouseenter', function () {
      this.style.transition = 'transform .2s cubic-bezier(.34,1.56,.64,1), box-shadow .2s ease, border-color .2s ease';
    });
  });

});
